<template>
  <div class="content">
    <el-backtop></el-backtop>
    <div>
      <div class="head">
        <!-- 导航栏部分 -->
        <div style="flex: 1 1 auto;">
          <el-menu :default-active="activeIndex" mode="horizontal" :router="true">
            <el-menu-item index="/workplace">工作台</el-menu-item>
            <el-submenu index="2">
              <template slot="title">流程中心</template>
              <el-menu-item index="/myWork">我的待办</el-menu-item>
              <el-menu-item index="/flow?type=2">我发起的</el-menu-item>
              <el-menu-item index="/flow?type=3">我处理的</el-menu-item>
              <el-menu-item index="/flow?type=4">抄送我的</el-menu-item>
            </el-submenu>
            <el-menu-item index="3" disabled>|</el-menu-item>
            <el-menu-item index="/createFlow" >发起新流程</el-menu-item>
          </el-menu>
        </div>
        <div>
          <el-input
            clearable
            prefix-icon="el-icon-search"
            v-model="searchKeyword"
            size="small"
            placeholder="请输入搜索关键词"
            @change="onSearch"
          />
        </div>
      </div>

      <div class="main">
        <div class="item" v-for="group in flowList">
          <div class="title" >{{group.name}}</div>
          <el-divider></el-divider>
          <div class="item_all" v-if="group.children && group.children.length > 0">
            <div
              class="item_item"
              v-for="item in group.children"
              :style="'border-top-color:' + item.color"
              @click="gotoPage(item)"
            >
              <div class="form_name">{{ item.name }}</div>
              <el-divider style="margin: 16px 0"></el-divider>
              <div class="item_item_bottom">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "../../api/workbenchApi";
import { Search } from "vant";
export default {
  components: {
    [Search.name]: Search,
  },
  data() {
    return {
      input: "",
      flowList: [],
      originalFlowList: [],
      activeIndex: this.$route.path,
      searchKeyword: ''
    };
  },
  mounted() {
    this.getFlow();
  },
  methods: {
    getFlow() {
      let param = { appID: '90002' }; //固定写死
      api.listAppDetailTreeByAppID(param)
        .then((res) => {
          if (res.success) {
            res.data.forEach(item => {
              if (item.children) {
                item.children.forEach(child => {
                  child.color = this.randomRgb()
                })
              }
            })
            this.originalFlowList = res.data || [];
            this.onSearch()
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message.error("请求失败！");
        });
    },
    gotoPage(appDetail) {
      // this.$router.push({
      //   path: appDetail.sysFunTransactionURL
      // });
      let url = '/dataView?funCode='+appDetail.sysFunTransactionID
      this.$router.push({
        path: url,
      })
      // window.location.href = appDetail.sysFunTransactionURL;
      // window.location.reload(true);
    },
    randomRgb() {
      let R = Math.floor(Math.random() * 130 + 110);
      let G = Math.floor(Math.random() * 130 + 70);
      let B = Math.floor(Math.random() * 130 + 110);
      return "rgb(" + R + "," + G + "," + B + ")";
    },
    onSearch() {
      this.flowList = JSON.parse(JSON.stringify(this.originalFlowList));
      if (this.searchKeyword.trim() !== '') {
        this.flowList.forEach(group => {
          if (group.children && group.children.length > 0) {
            group.children = group.children.filter(item => {
              return item.name.toLowerCase().includes(this.searchKeyword.toLowerCase());
            });
          }
        });
        this.flowList = this.flowList.filter(item => {
          return item.children.length > 0;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content .head {
  display: flex;
  position: fixed;
  align-items: center;
  top: 0;
  width: 100vw;
  padding: 0 60px 0 20px;
  background-color: #fff;
  border-bottom: solid 1px #e6e6e6;
  z-index: 200;
  box-sizing: border-box;
}
.workplace_nav {
  height: 60px;
  position: fixed;
  width: 100%;
  z-index: 1;
}
img.nav_img {
  width: 30px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  border-radius: 25px;
  vertical-align: middle;
  /* margin-left: 9px; */
}
.bread {
  display: inline-block;
  font-size: 16px;
}

.main {
  padding: 80px 20px 20px;
  text-align: center;
  max-width: 1000px;
  margin: auto;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: bold;
}

.item_item_bottom {
  margin-top: -20px;
  color: #007effd9;
  text-align: right;
  margin-right: 5px;
  background-color: #fff;
  padding-bottom: 10px;
}
span.flow {
  font-size: 12px;
  display: inline-block;
  margin-right: 5px;
}
span.right {
  font-size: 20px;
  display: inline-block;
  vertical-align: bottom;
  height: 23px;
}
.form_name {
  font-size: 15px;
  padding-left: 10px;
  padding-top: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}
.item{
  margin-top: 20px;
}
.item_all {
  display: flex;
  align-items: start;
  flex-wrap: wrap;
  text-align: left;
  .item_item {
    width: calc(25% - 16px);
    margin-right: 20px;
    flex-shrink: 0;
    border-top: 6px solid;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 20px;
    box-sizing: border-box;
    border-top: 6px solid;
    background-color: #fff;
    display: inline-block;
    vertical-align: top;
    box-shadow: 2px 2px 10px #e4ebf3;
    cursor: pointer;
    &:nth-child(4n){
      margin-right: 0;
    }
  }
}
::v-deep .el-card__body {
    padding: 20px;
    display: flex;
    align-items: center;
}
::v-deep .el-menu.el-menu--horizontal {
    border-bottom: none;
}
::v-deep.el-card.is-always-shadow{
  -webkit-box-shadow: 0 0 0 0 #fff;
   box-shadow: 0 0 0 0 #fff;

}
</style>
